import React from "react";
import tomocard from "../../../assets/tomo_card-black_no_t.png";
import gradientT from "../../../assets/gradient_t.svg";

/**
 * @description (desktop-only) visual component that appears on the left
 * side after a user is redirected from the confirmation email.
 */
const SignupDescriptionV2 = () => {
  return (
    <div className="halfStepContainer bg-white">
      <div
        id="signupDescription"
        className="h-full flex flex-grow"
      >
        <div className="px-12 m-auto max-w-full text-center">
          <div
            id="descriptionTitle"
            className="font-bold leading-none mb-5 mx-auto"
            style={{ fontSize: "3.5rem" } /* between 5xl and 6xl */}
          >
            <h1>
              Welcome to <br />
              <span className="text-primary">tomo</span>rrow.
            </h1>
          </div>
          <p className="text-xl font-light">We don&apos;t pull your credit.</p>
          <div id="descriptionImage mx-auto" style={{ position: "relative" }}>
            <img
              alt="tomocredit card"
              src={tomocard}
              className="w-5/12 py-4 mx-auto"
            />
            <img
              alt="tomocredit t logo"
              src={gradientT}
              className="absolute top-0 right-0 bottom-0 left-0 m-auto"
              style={{ width: "7%" }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignupDescriptionV2;
